import router from "@/router";
import AuthServices from "@/services/AuthService";
import handleAlert from "@/utils/HandleAlert";
import { getToken, removeToken, setToken } from "@/utils/HandleToken";

export default {
  namespaced: true,
  state: {
    isAuth: false,
    headerName: "",
    form: {},
    userData: {},
    menuData: [],
    isSidebarHide: false
  },
  mutations: {
    SET_IS_AUTH(state) {
      state.isAuth = !state.isAuth;
    },
    SET_FORM(state, value) {
      state.form = value;
    },
    SET_USERDATA(state, value) {
      state.userData = value;
    },
    SET_MENUDATA(state, value) {
      state.menuData = value;
    },
    SET_HEADERNAME(state, value) {
      state.headerName = value;
    },
    SET_SIDEBAR_HIDE(state) {
      state.isSidebarHide = !state.isSidebarHide;
    }
  },
  actions: {
    async login({ commit, state, dispatch }) {
      try {
        const result = await AuthServices.login(state.form);
        setToken(result.data.token);
        handleAlert({ commit, dispatch }, result, null);
        router.go();
      } catch (error) {
        handleAlert({ commit, dispatch }, null, error);
      } finally {
        commit("SET_USERDATA", {});
      }
    },
    async readUserByToken({ commit, dispatch }) {
      const token = getToken();
      try {
        const result = await AuthServices.readUserByToken(token);
        commit("SET_IS_AUTH");
        commit("SET_USERDATA", result.data);
        commit("SET_MENUDATA", result.data.menu);
      } catch (error) {
        handleAlert({ commit, dispatch }, null, error);
      }
    },
    async logout({ commit, dispatch }) {
      try {
        const token = getToken();
        const result = await AuthServices.logout(token);
        handleAlert({ commit, dispatch }, result, null);
        if (result) {
          commit("SET_MENUDATA", []);
          commit("SET_USERDATA", {});
          commit("SET_IS_AUTH");
          removeToken();
          router.push({ name: "login" });
        }
      } catch (error) {
        handleAlert({ commit, dispatch }, null, error);
      }
    },
    toggleSidebar({ commit }) {
      commit("SET_SIDEBAR_HIDE");
    }
  },
  getters: {
    isAuth: (state) => state.isAuth,
  },
};
